import { tWithKeyAttr as t } from "../../i18nHelper";
import myCalendarStyles from "./myCalendar.module.css";
import groupUsersIcon from "../../images/group_users_icon.svg";

import Calendar from "react-calendar";
import React, { Dispatch, SetStateAction, useState } from "react";
import { getDuration } from "../../utils/utils";
import { Category, IAppointment } from "../../types/types";
import Modal from "../modals/modal/Modal";
import AppointmentCard from "../modals/appointmentCard/appointmentCard";
import NoAppointments from "../noAppointments/noAppointments";
import { useAppSelector } from "../../services/hooks";
import { userAppointmentsSelector } from "../../services/selectors/user.selectors";
import i18n from "../../i18n";

function MyCalendar({ setActiveCategory }: { setActiveCategory: Dispatch<SetStateAction<Category>> }) {
  const userAppointments = useAppSelector(userAppointmentsSelector)?.filter(a => a.appointments.appointmentDate && a.appointments.statusId !== 0);
  const [activeDate, setActiveDate] = useState(new Date());
  const [openModal, setOpenModal] = useState(false);
  const [appointmentData, setAppointmentData] = useState<IAppointment | null>(
    null
  );


  return (
    <section dir={i18n.dir()} className={myCalendarStyles.myCalendar}>
      {openModal && appointmentData && (
        <Modal onClose={() => setOpenModal(false)}>
          <AppointmentCard
            onClose={() => setOpenModal(false)}
            appointmentData={appointmentData}
          />
        </Modal>
      )}
      <h2 className={myCalendarStyles.myCalendar__title}>{t('MY_MEETINGS')}</h2>
      {userAppointments?.length ? (
        <div className={myCalendarStyles.calendarSection}>
          <Calendar
            calendarType={"gregory"}
            locale={i18n.language}
            onClickDay={setActiveDate}
            value={activeDate}
            prev2Label={null}
            next2Label={null}
            tileContent={({ date }) => {
              const appointments: IAppointment[] = userAppointments.filter(
                (ap) => new Date(ap.appointments.appointmentDate).toDateString() === date.toDateString()
              ).slice(0, 3);
              if (appointments) {
                return (
                  <div className={myCalendarStyles.circleContainer}>
                    {appointments.map((a, index) => (
                      <span
                        key={index}
                        className={myCalendarStyles.circle}
                        style={{ background: `#5D3CC7` }}
                      />
                    ))}
                  </div>
                );
              } else {
                return null;
              }
            }}
            className={myCalendarStyles.myCalendar}
          />
          <div className={myCalendarStyles.appointmentsContainer}>
            {userAppointments?.length ? (
              <ul className={myCalendarStyles.appointmentsList}>
                {userAppointments
                  .filter(
                    (app) =>
                      new Date(app.appointments.appointmentDate).toDateString() === activeDate.toDateString()
                  )
                  .map((a, index) => (
                    <li
                      key={index}
                      className={myCalendarStyles.appointmentsLi}
                      onClick={() => {
                        setAppointmentData(a);
                        setOpenModal(true);
                      }}
                    >
                      {(a.appointments?.startTime && a.appointments?.endTime) && (
                        <div className={myCalendarStyles.time}>
                          <span
                            className={`${myCalendarStyles.circle} ${myCalendarStyles.circle_big}`}
                            style={{ background: `#5D3CC7` }}
                          />
                          <p className={myCalendarStyles.duration}>
                            {getDuration(
                              new Date(a.appointments.appointmentDate),
                              a.appointments.startTime,
                              a.appointments.endTime
                            )}
                          </p>
                        </div>
                      )}
                      <p className={myCalendarStyles.name}>
                        {a.appointments.treatmentGroupId && (
                          <span
                            className={myCalendarStyles.groupBadge}
                            style={{ backgroundImage: `url(${groupUsersIcon})` }}
                            role="img"
                            aria-label={t("CALENDAR_TREATMENT_GROUP") || "Group"}
                            title={t("CALENDAR_TREATMENT_GROUP") || "Group"}
                            onClick={(e) => e.stopPropagation()}
                          />)}
                        {a.therapistName}
                      </p>
                      {a.appointments.treatmentGroupId && (
                        <>

                          {/* Render group members if available (safe any cast) */}
                          {(a.groupMembers && a.groupMembers.length) ? (
                            <ul className={myCalendarStyles.groupMembersList}>
                              {((a).groupMembers).map((name, mi) => {
                                const initials = (name ? name.split(' ').map((n: string) => n[0]).join('').slice(0, 2) : '').toUpperCase();
                                return (
                                  <li key={mi} className={myCalendarStyles.groupMemberItem} onClick={(e) => e.stopPropagation()} title={name || t('UNKNOWN_USER')}>
                                    <span className={myCalendarStyles.groupMemberAvatar} aria-hidden>
                                      {initials || '?'}
                                    </span>
                                    <span className={myCalendarStyles.groupMemberName}>{name || t('UNKNOWN_USER')}</span>
                                  </li>
                                );
                              })}
                            </ul>
                          ) : null}
                        </>
                      )}
                    </li>
                  ))}
              </ul>
            ) : null}
          </div>
        </div>
      ) : (
        <NoAppointments setActiveCategory={setActiveCategory} />
      )}
    </section>
  );
}

export default MyCalendar;
